<template>
  <div>
    <CurrentDate :format="dateFormat" />
    <GoSearchForm
      :page="results.currentPage"
      :term="results.term"
      :searching="results.searched"
      v-on:update:searching="search($event)"
    />
    <div class="results">
      <SearchQueryTotals :results="results" :info="results.info" />
      <SearchPagination
        class="pagination"
        :sizeValue="results.sizeValue"
        :fromValue="results.fromValue"
        :currentPage="results.currentPage"
        :totalPages="results.totalPages"
        v-on:update:next="nextClicked"
        v-on:update:prev="prevClicked"
      />
      <GoSearchResults :results="results.results" />
      <SearchPagination
        class="pagination bottom"
        :sizeValue="results.sizeValue"
        :fromValue="results.fromValue"
        :currentPage="results.currentPage"
        :totalPages="results.totalPages"
        v-on:update:next="nextClicked"
        v-on:update:prev="prevClicked"
      />
    </div>
  </div>
</template>

<script>
import CurrentDate from "@/components/CurrentDate";
import SearchPagination from "@/components/SearchPagination";
import SearchQueryTotals from "@/components/SearchQueryTotals";
import GoSearchForm from "@/components/GoSearchForm";
import GoSearchResults from "@/components/GoSearchResults";

export default {
  name: "GoSearch",
  data() {
    return {
      dateFormat: "dddd, MMMM Do, YYYY",
      results: {
        info: "detailed",
        term: "",
        currentPage: 1,
        endPage: 1,
        sizeValue: 20,
        fromValue: 0,
        totalPages: 1,
        results: [],
        suggestions: {},
        totals: 0,
        searched: false
      }
    };
  },
  components: {
    CurrentDate,
    SearchPagination,
    SearchQueryTotals,
    GoSearchForm,
    GoSearchResults
  },
  watch: {
    $route(to, from) {
      const tempObject = {};
      tempObject.term = to.query.qt;
      this.updateTerm(tempObject);
    }
  },
  methods: {
    updateTerm(value) {
      this.results.suggestionTrigger = false;
      this.results.term = value.term;
    },
    search(value) {
      this.results.endPage = value.endPage;
      this.results.fromValue = value.fromValue;
      this.results.results = value.results;
      this.results.searched = value.searched;
      this.results.sizeValue = value.sizeValue;
      this.results.startResults = value.startResults;
      this.results.term = value.term;
      this.results.totalPages = value.totalPages;
      this.results.totals = value.totals;
      this.setResultsPath();
    },
    setResultsPath() {
      this.$router
        .push({
          name: "go",
          query: {
            qt: this.results.term,
            pg: this.results.currentPage
          }
        })
        .catch(error => {
          // do nothing
        });
    },
    nextClicked() {
      this.$emit("update:next");
      this.results.currentPage++;
    },
    prevClicked() {
      this.$emit("update:prev");
      this.results.currentPage--;
    }
  }
};
</script>

<style lang="scss" scoped>
.date {
  text-align: right;
  font-size: $size-7;
}
.results {
  font-size: $size-7;
  margin: 0 5em;
  text-align: left;
  &-totals {
    margin: 0 5em;
    border-top: none;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin: -1em 3em 1em 0;
  &.bottom {
    margin: 0 3em 1em 0;
  }
  :first-child,
  :last-child {
    color: darken($blue, 5%);
    background-color: transparent !important;
    &:hover {
      color: darken($blue, 25%);
      background-color: transparent !important;
    }
  }
  &:after {
    clear: both;
  }
}
</style>
